import { useBooleanQueryParam } from 'hooks/queryParams';

export const useCumulative = () => useBooleanQueryParam('cumulative');
